export const ImpactTypes = ['positive', 'negative', 'unknown'];
export const NormalRangeRelationEnum = {
    ABOVE: 'above',
    BELOW: 'below',
    IN: 'in'
};
export const findingSourceTypesEnum = {
    ADVISOR: 'advisor',
    CALCULATOR: 'calculator',
    FHIR: 'fhir',
    SMARTDOC: 'smart_doc',
};
export const FindingType_Enumerated = 'enumerated';
export const FindingType_Range = 'range';
export const FindingType_Numeric = 'numeric';
export const FindingType_Textual = 'textual';
export const FindingTypes = [FindingType_Enumerated, FindingType_Numeric, FindingType_Range, FindingType_Textual];
//# sourceMappingURL=types.js.map